// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__cYJEy","ranges":"BmiRanges_ranges__1qnzk"};